<ng-container *ngLet="languages$ | async as languages">
    <mat-select *ngIf="languages?.length > 0"
                [value]="currentLanguage$ | async"
                [placeholder]="'a11y_language_selector' | translate"
                (selectionChange)="changeLanguage($event.value)"
                panelClass="ui-language-selector-options-container">
        <mat-select-trigger>
            <mat-icon svgIcon="uipath:worldwide"></mat-icon>
            <span class="current-language">{{ (currentLanguage$ | async)?.DisplayName }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let language of languages"
                    [attr.aria-label]="language.Name === 'ja' ? language.DisplayName : ''"
                    [attr.data-cy]="language.Name"
                    [value]="language">
            <ng-container *ngIf="language.Name === 'ja'; else languageText">
                <mat-icon svgIcon="uipath:language_ja"
                          class="japanese-language-text"></mat-icon>
            </ng-container>
            <ng-template #languageText>
                {{ language.DisplayName }}
            </ng-template>
        </mat-option>
    </mat-select>
</ng-container>
